import type { PharmacyIdType } from '@app/icare/entities/pharmacy/schema/Pharmacy'
import { ContactPersonTable } from '@app/icare/routes/_app/apotheken/-components/ContactPersonTable'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/apotheken/$id/contact-persons')({
  component: RouteComponent,
})

function RouteComponent() {
  return <ContactPersonTable ownerId={Route.useParams().id as PharmacyIdType} />
}
